const jsonHelper = async (seriesId) => {
    const url = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
    try {
      // cache: 'no-cache' forces a conditional revalidation against the CDN so
      // freshly published rows (e.g. new LVT install patterns) show up without
      // waiting for the edge to expire its cached copy.
      const response = await fetch(url, { cache: 'no-cache' });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const jsonData = await response.json();
      return jsonData;
    } catch (error) {
      throw new Error(error.message);
    }
  };
  
  export {jsonHelper};  // Default export
  